module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_3009.70cd80e0.png";